<template>
  <div>
    <tiptap-vuetify
      v-model="content"
      :extensions="extensions"
      min-height="300"
    />
  </div>
</template>

<script>

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify';

export default {
  components: { TiptapVuetify },
  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3],
          },
        }],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  computed: {
    content: {
      get() {
        return this.$store.state.richeditor.text;
      },
      set(val) {
        this.$store.commit('richeditor/setText', val);
      },
    },
  },

};

</script>
<style>
.tiptap-vuetify-editor__content {
  min-height: 300px;
}
.tiptap-vuetify-editor  .ProseMirror{
  min-height: 300px;
}
</style>
